<div
  class="h-full min-h-0 overflow-hidden rounded-lg border border-gray-300 bg-white"
>
  <div class="h-full min-h-0 overflow-auto">
    <table
      class="min-w-[900px] sm:min-w-full border-separate border-spacing-0 text-sm text-gray-700"
    >
      <thead class="font-semibold">
        <tr>
          <th
            class="sticky top-0 z-10 cursor-pointer select-none bg-slate-600 p-3 text-left text-slate-100 hover:bg-slate-500"
            (click)="onHeaderClick('document_number')"
          >
            <div class="flex items-center gap-1">
              Payment #
              <lib-sort-icon
                [active]="sortBy() === 'document_number'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 cursor-pointer select-none bg-slate-600 p-3 text-left text-slate-100 hover:bg-slate-500"
            (click)="onHeaderClick('invoice_number')"
          >
            <div class="flex items-center gap-1">
              Invoice #
              <lib-sort-icon
                [active]="sortBy() === 'invoice_number'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 cursor-pointer select-none bg-slate-600 p-3 text-left text-slate-100 hover:bg-slate-500"
            (click)="onHeaderClick('invoice_recipient_name')"
          >
            <div class="flex items-center gap-1">
              Payer
              <lib-sort-icon
                [active]="sortBy() === 'invoice_recipient_name'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 cursor-pointer select-none bg-slate-600 p-3 text-left text-slate-100 hover:bg-slate-500"
            (click)="onHeaderClick('payee_name')"
          >
            <div class="flex items-center gap-1">
              Payee
              <lib-sort-icon
                [active]="sortBy() === 'payee_name'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
          >
            Type
          </th>
          <th
            class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
          >
            Method
          </th>
          <th
            class="sticky top-0 z-10 cursor-pointer select-none bg-slate-600 p-3 text-right text-slate-100 hover:bg-slate-500"
            (click)="onHeaderClick('amount_minor')"
          >
            <div class="flex items-center justify-end gap-1">
              Amount
              <lib-sort-icon
                [active]="sortBy() === 'amount_minor'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th
            class="sticky top-0 z-10 cursor-pointer select-none bg-slate-600 p-3 text-left text-slate-100 hover:bg-slate-500"
            (click)="onHeaderClick('payment_date')"
          >
            <div class="flex items-center gap-1">
              Date
              <lib-sort-icon
                [active]="sortBy() === 'payment_date'"
                [direction]="sortDirection()"
              />
            </div>
          </th>
          <th class="sticky top-0 z-10 bg-slate-600 p-3 text-slate-100">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
        @for (payment of payments(); track payment.id) {
        <tr class="text-sm transition-colors duration-150 hover:bg-gray-50">
          <td class="cursor-pointer p-3" (click)="viewPayment.emit(payment)">
            <div class="font-mono font-medium text-gray-900">
              {{ payment.document_number }}
            </div>
          </td>

          <td class="cursor-pointer p-3" (click)="viewPayment.emit(payment)">
            <div class="font-mono font-medium text-gray-900">
              {{ payment.invoice_number || '-' }}
            </div>
          </td>

          <td class="cursor-pointer p-3" (click)="viewPayment.emit(payment)">
            <div class="font-medium text-gray-900">
              {{ payment.invoice_recipient_name || '-' }}
            </div>
          </td>

          <td class="cursor-pointer p-3" (click)="viewPayment.emit(payment)">
            <div class="font-medium text-gray-900">
              {{ payment.payee_name || '-' }}
            </div>
          </td>

          <td class="p-3">
            <span
              class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
              [class]="paymentTypeClass(payment.type)"
            >
              {{ paymentTypeLabel(payment.type) }}
            </span>
          </td>

          <td class="p-3 whitespace-nowrap">
            {{ paymentMethodLabel(payment.payment_method) }}
          </td>

          <td
            class="p-3 whitespace-nowrap text-right font-medium"
            [class.text-red-700]="payment.amount_minor < 0"
            [class.text-gray-900]="payment.amount_minor >= 0"
          >
            {{ formatMoney(payment.amount_minor, payment.currency) }}
          </td>

          <td class="p-3 whitespace-nowrap">
            {{ formatDate(payment.payment_date) }}
          </td>

          <td class="p-3 text-right">
            @if (canView()) {
            <lib-view-icon-button
              title="View Payment"
              variant="gray"
              size="md"
              (clicked)="viewPayment.emit(payment)"
            />
            }
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="9">
            <shared-no-records-placeholder
              title="No payments found"
              description="Commission payments will appear here once recorded."
            />
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
